//Colores de la aplicación
export const PANTONES_PRINCIPALES = {
    VERDE: '#3F9C35',
    ROJO: '#E00034',
    AMARILLO: '#FFA100',
    AZUL: '#00549F',
    GRIS: '#b5b7b9',
    BLANCO: '#FFFFFF'
}